import { Component, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-pricing',
  templateUrl: './new-pricing.component.html',
  styleUrls: ['./new-pricing.component.scss']
})
export class NewPricingComponent {
   constructor(private renderer: Renderer2,private router:Router) {}

  updateSpotlight(event: MouseEvent, plan: string) {
    const card = event.currentTarget as HTMLElement;
    const rect = card.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    this.renderer.setStyle(card, '--x', `${x}px`);
    this.renderer.setStyle(card, '--y', `${y}px`);
  }

  clearSpotlight(plan: string) {
    const card = document.querySelector(`.pricing-card.${plan}`) as HTMLElement;
    if (card) {
      this.renderer.setStyle(card, '--x', `-9999px`);
      this.renderer.setStyle(card, '--y', `-9999px`);
    }
  }
  naivaigate(data:any){
    this.router.navigate(['/pricing-overview'])
    
  } 
  rounteToDemo(){ 
    let hom=window.location.href
    console.log(hom) 
    this.router.navigate(['/contacts']); 
    setTimeout(()=>{ 
    this.scrollTOView5(); 
    },400) 
  }
  scrollTOView5(){
    window.scrollTo(0, 2);
  } 

}
